<template>
  <e-charts :options="options" theme='light' :autoresize="true" :key="key" style="height: 100%"/>
</template>

<script lang="js">
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'

@Component({components: {ECharts}})
export default class BarChart extends Vue {
  @Prop() data;
  @Prop() xAxis;
  @Prop({default(){return{type: 'value'}}})  yAxis;
  @Prop()  series;
  @Prop()  name;
  @Prop({default:'{b}: <b>{c}</b>'})  tooltipFormat;
  key = 0;
  get options() {return {
    tooltip: {
      trigger: 'item',
      formatter: this.tooltipFormat
    },
    grid:{
      left:'60',
      right:'40',
      top:'10',
      bottom:'30',
    },
    xAxis: {
      type: 'category',
      data: this.xAxis
    },
    yAxis: this.yAxis,
    series: this.series || [
      {
        type: 'bar',
        name: this.name,
        data: this.data,
      },
    ],
    animationDuration: 1000
  }};

  @Watch('data', { deep: true })
  onDataChanged() {
    this.key++
  }
}
</script>

<style>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
